import authClient from "services/httpClient/authClient";
import { InitialValues } from "pages/Auth/login/SignIn";
import { RecoverPasswordPayload, RecoverPasswordResponse, ResetPasswordPayload, ResetPasswordResponse } from "./models";

export const login = (payload: InitialValues) => {
  return authClient.post("/api/Account/login", payload);
};

export const recoverPassword = (payload: RecoverPasswordPayload) => {
  return authClient.post<RecoverPasswordResponse>("/api/Account/recover-password", payload);
}

export const resetPassword = (payload: ResetPasswordPayload) => {
  return authClient.post<ResetPasswordResponse>("/api/Account/reset-password", payload);
}

export const logOutUser =()=>{
  return authClient.post("/api/Account/logout")
}
